<template>
    <!-- height 属性非常的关键，限制 carousel 不要太高，这样就会形成一个滚动字幕的展现形式 -->
    <flipupper :texts="$store.state.slogans" :width="310" font-class="font-warning"></flipupper>
</template>

<script>
    import Flipupper from "./commons/Flipupper";
    export default {
        name: "Slogan",
        components: {Flipupper}
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Slogan.vue